/**
 * Project: redwood-ui-components
 * FilePath: /src/client/app/applications/redwood-table/Table.js
 * File: Table.js
 * Created Date: Wednesday, February 27th 2019, 7:05:23 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Apr 05 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Pixel Ventures Ltd.
 * ------------------------------------
 */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { FusePageSimple } from 'modules/@fuse'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import withReducer from 'modules/@fuse/store/withReducer'

import { Table } from '../../../../lib'

const { TableComponent, getTableReducers } = Table
const EXAMPLE_ID = 'EXAMPLE_ID'
const reducer = getTableReducers(EXAMPLE_ID)
const selectors = {
  selectSelectedRows: state => state && state.selection && state.selection.selectedRows,
  selectColumnsToHide: state => state && state.hiddenColumns
}

const styles = theme => ({
  layoutRoot: {}
})

const _props = {
  'typeDefinition': {
    type: 'PROJECT_SUMMARY',
    valueType: 'STRING',
    props: [{
      type: 'PROJECT_STAR',
      valueType: 'BOOLEAN',
      queryAliases: {
        en: {
          tokens: ['Star']
        }
      },
      props: [{
        type: 'ICON',
        valueType: 'STRING'
      }],
      propRefs: ['ICON']
    }, {
      type: 'PROJECT_NAME',
      valueType: 'STRING',
      queryAliases: {
        en: {
          tokens: ['Name']
        }
      }
    }, {
      type: 'PROJECT_CLIENT',
      valueType: 'STRING',
      queryAliases: {
        en: {
          tokens: ['Client']
        }
      }
    }, {
      type: 'PROJECT_DATE',
      valueType: 'DATETIME',
      queryAliases: {
        en: {
          tokens: ['Date Last Accessed']
        }
      }
    }, {
      type: 'PROJECT_OWNER',
      valueType: 'STRING',
      queryAliases: {
        en: {
          tokens: ['Owner']
        }
      }
    }, {
      type: 'PROJECT_SIZE',
      valueType: 'NUMBER',
      queryAliases: {
        en: {
          tokens: ['Total Size']
        }
      }
    }],
    propRefs: ['PROJECT_STAR', 'PROJECT_NAME', 'DATE', 'OWNER', 'SIZE'],
    loading: false
  },
  'panelIdentifier': 'PROJECT_PANEL',
  'entities': [
    {
      'props': [{
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'PROJECT_STAR',
        'template': false,
        'valueType': 'BOOLEAN',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value7': false,
        'value': 'value7'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'PROJECT_NAME',
        'template': false,
        'valueType': 'STRING',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value0': 'Alpha',
        'value': 'value0'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'CLIENT',
        'template': false,
        'valueType': 'STRING',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value0': 'Internal',
        'value': 'value0'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'DATE',
        'template': false,
        'valueType': 'DATETIME',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value3': '0',
        'value': 'value3'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'OWNER',
        'template': false,
        'valueType': 'STRING',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value0': 'bcb613e2-6244-4a45-a198-c634ac23d05d',
        'value': 'value0'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'SIZE',
        'template': false,
        'valueType': 'NUMBER',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value1': '0',
        'value': 'value1'
      }],
      'processingAliases': [],
      'propRefs': [],
      'queryAliases': {},
      'type': 'PROJECT_SUMMARY',
      'template': false,
      'valueType': 'STRING',
      'token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJaMXVhMjB0IiwicHJvamVjdCI6IlpleGs3MyIsInBlcm1zIjpbImludHJvZHVjZSIsImRlc3Ryb3kiLCJyZXNvbHZlIl0sImlhdCI6MTU0NjYxMzU2NiwiaXNzIjoiYW5leHN5cy5yZWR3b29kLnByb2plY3QiLCJzdWIiOiJkY2FhYmU0ZS1jNGM1LTQzYmMtYmJiYy1iMTcxNjNkZGUwN2YifQ.yTdNUw6jWJ3mkJ0tM2AwgyQUpfXS8zFR3hpGGSsCvIdTzDpWpczhCtxN1QZJ5TDaJa-mKR4jWwKxbpQkMISnsmFh1plrUxsl_FpcWH9ISACeOKhYo99rZaMKGtM8-Q0xyWtjslCpSUfhyM31M_mx8L-_jTSsw4IMVkgaxXoRgbNZCccUgSemunfPQXTF9r9cbvlIc-Ie7ow_3mWhmVMvwhxUJd2knaukt8MXl68mYSw_d0JZbRuLjivS-ftzpKQyWopEGhPJCql_8fGe__SM9cN82E3uK0ASvGvRmEVqferYKn-kV1fM1Fd8gpXINkjSvsiXfdHaXhVTQKlJHnOHVw',
      'source': '',
      'creator': 'bcb613e2-6244-4a45-a198-c634ac23d05d',
      'tt': 'NONE',
      'value0': 'Zexk73',
      'value': 'value0'
    },
    {
      'props': [{
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'PROJECT_STAR',
        'template': false,
        'valueType': 'BOOLEAN',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value7': true,
        'value': 'value7'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'PROJECT_NAME',
        'template': false,
        'valueType': 'STRING',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value0': 'Beta',
        'value': 'value0'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'CLIENT',
        'template': false,
        'valueType': 'STRING',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value0': 'Internal',
        'value': 'value0'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'DATE',
        'template': false,
        'valueType': 'DATETIME',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value3': '0',
        'value': 'value3'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'OWNER',
        'template': false,
        'valueType': 'STRING',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value0': 'bcb613e2-6244-4a45-a198-c634ac23d05d',
        'value': 'value0'
      }, {
        'props': [],
        'processingAliases': [],
        'propRefs': [],
        'queryAliases': {},
        'type': 'SIZE',
        'template': false,
        'valueType': 'NUMBER',
        'token': '',
        'source': '',
        'creator': '',
        'tt': 'NONE',
        'value1': '0',
        'value': 'value1'
      }],
      'processingAliases': [],
      'propRefs': [],
      'queryAliases': {},
      'type': 'PROJECT_SUMMARY',
      'template': false,
      'valueType': 'STRING',
      'token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJaMXVhMjB0IiwicHJvamVjdCI6IlpleGs3MyIsInBlcm1zIjpbImludHJvZHVjZSIsImRlc3Ryb3kiLCJyZXNvbHZlIl0sImlhdCI6MTU0NjYxMzU2NiwiaXNzIjoiYW5leHN5cy5yZWR3b29kLnByb2plY3QiLCJzdWIiOiJkY2FhYmU0ZS1jNGM1LTQzYmMtYmJiYy1iMTcxNjNkZGUwN2YifQ.yTdNUw6jWJ3mkJ0tM2AwgyQUpfXS8zFR3hpGGSsCvIdTzDpWpczhCtxN1QZJ5TDaJa-mKR4jWwKxbpQkMISnsmFh1plrUxsl_FpcWH9ISACeOKhYo99rZaMKGtM8-Q0xyWtjslCpSUfhyM31M_mx8L-_jTSsw4IMVkgaxXoRgbNZCccUgSemunfPQXTF9r9cbvlIc-Ie7ow_3mWhmVMvwhxUJd2knaukt8MXl68mYSw_d0JZbRuLjivS-ftzpKQyWopEGhPJCql_8fGe__SM9cN82E3uK0ASvGvRmEVqferYKn-kV1fM1Fd8gpXINkjSvsiXfdHaXhVTQKlJHnOHVw',
      'source': '',
      'creator': 'bcb613e2-6244-4a45-a198-c634ac23d05d',
      'tt': 'NONE',
      'value0': 'Zexk74',
      'value': 'value0'
    }
  ]
}

class TableFuse extends Component {
  render () {
    const {
      loading,
      typeDefLoading,
      classes
    } = this.props

    return typeDefLoading || loading ? (
      <p>Loading...</p>
    ) : (
      <FusePageSimple
        classes={{
          root: classes.layoutRoot
        }}
        content={
          <div style={{ height: '100vh' }}>
            <TableComponent
              resizable
              entities={_props.entities}
              typeDefinition={_props.typeDefinition}
              selectEntitites={selectors.selectEntityItems}
              panelIdentifier={EXAMPLE_ID}
              selectedRowsSelector={selectors.selectSelectedRows}
              selectColumnsToHide={selectors.selectColumnsToHide}
              columnsToHide={[]}
            />
          </div>
        }
        onRef={instance => {
          this.pageLayout = instance
        }}
      />
    )
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({

  }, dispatch)
}

function mapStateToProps ({ tableApp }) {
  return {}
}

export default withReducer('tableApp', reducer)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      connect(mapStateToProps, mapDispatchToProps)(TableFuse)
    )
  )
)
